import { CircleCheck } from 'lucide-react'
import { Toaster } from 'sonner'

export const Toast = () => {
  return (
    <Toaster
      position='top-center'
      toastOptions={{
        style: {
          background: '#26004B',
          color: '#fff',
          borderColor: '#4A4A4A',
        },
        classNames: {
          title: 'color=[#fff] ml-4',
        },
      }}
      icons={{
        success: <CircleCheck stroke='#26004B' fill='#29845A' size={32} />,
      }}
    />
  )
}
